import ScrollContainer from 'react-indiana-drag-scroll';

import { useDevice } from '@contexts/device';
import Skeleton from '@components/skeletons/Skeleton';
import { FlexibleDiv } from '@components/formStyles';

import { ContentWrapper, PromotionItems } from './styled';

const CampaignDetailSkeleton = () => {
  const { isDesktop } = useDevice();
  return (
    <FlexibleDiv top={40}>
      <ContentWrapper>
        <FlexibleDiv bottom={40}>
          <Skeleton height={isDesktop ? 500 : 260} borderRadius={8} />
        </FlexibleDiv>

        <FlexibleDiv bottom={18}>
          <Skeleton width={307} height={17} borderRadius={8} />
        </FlexibleDiv>

        <FlexibleDiv bottom={18}>
          <Skeleton
            width={isDesktop ? 550 : 300}
            height={isDesktop ? 51 : 70}
            borderRadius={8}
          />
        </FlexibleDiv>

        <FlexibleDiv bottom={40}>
          <Skeleton height={51} borderRadius={8} />
        </FlexibleDiv>
        <ScrollContainer className='scroll-container'>
          <PromotionItems>
            {[1, 2, 3, 4].map((item) => (
              <Skeleton
                key={item}
                height={isDesktop ? 270 : 240}
                borderRadius={8}
              />
            ))}
          </PromotionItems>
        </ScrollContainer>
      </ContentWrapper>
    </FlexibleDiv>
  );
};

export default CampaignDetailSkeleton;
